import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import { AiChatStore } from 'src/app/services/ai-assistant/ai-chat-store.service';
import { AiPanelService } from 'src/app/services/ai-assistant/ai-panel.service';
import { AiPageContextService } from 'src/app/services/ai-assistant/ai-page-context.service';

/**
 * "Ask Crystal AI" — always visible in the header. Enter starts a NEW chat (linked to the case the
 * current page shows, if any) and opens the side panel with the question already sent.
 */
@Component({
  selector: 'ai-ask-bar',
  templateUrl: './ai-ask-bar.component.html',
  styleUrls: ['./ai-ask-bar.component.scss'],
  imports: [FormsModule, DxTextBoxModule, DxButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // The host reserves header space (flex-basis) — collapse it too when the assistant is not offered.
  host: { '[style.display]': "panel.available() ? null : 'none'" },
})
export class AiAskBarComponent {
  text = '';
  readonly placeholder = computed(() => {
    const ctx = this.pageContext.current();
    return ctx ? `Ask Crystal AI about ${ctx.caseReference}…` : 'Ask Crystal AI…';
  });

  constructor(
    private store: AiChatStore,
    readonly panel: AiPanelService,
    private pageContext: AiPageContextService,
  ) {}

  ask(): void {
    const question = this.text.trim();
    if (!question) {
      this.panel.show();
      return;
    }
    this.store.newChat();
    this.store.send(question, [], this.pageContext.current()?.caseId ?? null);
    this.text = '';
    this.panel.show();
  }

  /** Documents are attached in the panel's composer; open a fresh chat there. */
  attach(): void {
    this.store.newChat();
    this.panel.show();
  }

  openPanel(): void { this.panel.toggle(); }
}
